<template>
  <div v-if="comType == 'UI'">
    <div
      class="cube-content"
      :style="{
        height: `${comHeight}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
      }"
    >
      <div :class="layoutMode">
        <div
          v-for="(item, index) in imgUrlList.slice(0, layoutModeNumMap[layoutMode])"
          :key="index"
        >
          <img v-if="item.imgUrl" :src="item.imgUrl" />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="布局样式">
          <div class="mode-content">
            <div
              class="list"
              :class="[
                {
                  active: item == layoutModeValue,
                },
              ]"
              v-for="item in Object.keys(layoutModeNumMap)"
            >
              <div
                class="box"
                :class="[
                  item,
                  {
                    active: item == layoutModeValue,
                  },
                ]"
                @click="layoutModeValue = item"
              >
                <div v-for="subitem in new Array(layoutModeNumMap[item]).fill('')"></div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <div>
        <div class="collapse-content">
          <el-collapse :value="activeName" size="small">
            <el-collapse-item
              :name="index"
              :key="index"
              v-for="(item, index) in imgUrlListValue.slice(
                0,
                layoutModeNumMap[layoutModeValue]
              )"
            >
              <template slot="title">
                <el-form-item :label="`图片${index + 1}`">
                  <div class="collapse-title" @click.stop>
                    <jumpConfig :jumpLink.sync="item.jumpLink"></jumpConfig>
                  </div>
                </el-form-item>
              </template>
              <el-form-item label="">
                <customUpload :imageUrl.sync="item.imgUrl"></customUpload>
                <div class="tip">
                  {{ layoutModeTipMap[layoutModeValue][index] || "" }}
                </div>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div>
        <el-form-item label="高度">
          <div class="slider-block">
            <el-slider v-model="comHeightValue" show-input :min="1" :max="750">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="上间距">
          <div class="slider-block">
            <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下间距">
          <div class="slider-block">
            <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左间距">
          <div class="slider-block">
            <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右间距">
          <div class="slider-block">
            <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import customUpload from "@/components/appltDecoration/customUpload";
import jumpConfig from "@/components/appltDecoration/jumpConfig";
export default {
  name: "comCube",
  data() {
    return {
      layoutModeNumMap: {
        mode01: 2,
        mode02: 3,
        mode03: 2,
        mode04: 2,
        mode05: 3,
        mode06: 3,
      },
      layoutModeTipMap: {
        mode01: ["建议图片宽度 375px", "建议图片宽度 375px"],
        mode02: ["建议图片宽度 250px", "建议图片宽度 250px", "建议图片宽度 250px"],
        mode03: ["建议图片宽度 500px", "建议图片宽度 250px"],
        mode04: ["建议图片宽度 250px", "建议图片宽度 500px"],
        mode05: [
          "建议图片宽度 375px*376px",
          "建议图片宽度 375px*188px",
          "建议图片宽度 375px*188px",
        ],
        mode06: [
          "建议图片宽度 375px*188px",
          "建议图片宽度 375px*188px",
          "建议图片宽度 375px*376px",
        ],
      },
      activeName: [0, 1, 2],
    };
  },
  components: {
    customUpload,
    jumpConfig,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    layoutMode: {
      type: String,
      default: "mode01",
    },
    imgUrlList: {
      type: Array,
      default: () => {
        return [
          {
            imgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
            },
          },

          {
            imgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
            },
          },

          {
            imgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
            },
          },
        ];
      },
    },
    comHeight: {
      type: Number,
      default: 200,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    layoutModeValue: {
      get() {
        return this.layoutMode;
      },
      set(val) {
        this.$emit(`update:layoutMode`, val);
      },
    },
    imgUrlListValue: {
      get() {
        return this.imgUrlList;
      },
      set(val) {
        this.$emit(`update:imgUrlList`, val);
      },
    },
    comHeightValue: {
      get() {
        return this.comHeight;
      },
      set(val) {
        this.$emit(`update:comHeight`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.cube-content > div {
  height: 100%;
}

.cube-content > div > div img {
  width: 100%;
  height: 100%;
  display: block;
}

.cube-content .mode01,
.cube-content .mode02,
.cube-content .mode03,
.cube-content .mode04 {
  display: flex;
  flex-wrap: nowrap;
}

.cube-content .mode01 div,
.cube-content .mode02 div,
.cube-content .mode03 div,
.cube-content .mode04 div {
  height: 100%;
  flex: 1;
}

.cube-content .mode03 div:first-child,
.cube-content .mode04 div:nth-child(2) {
  flex: 2;
}

.cube-content .mode05,
.cube-content .mode06 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.cube-content .mode05 div,
.cube-content .mode06 div {
  flex: 1;
  max-width: 50%;
  min-width: 50%;
  min-height: 48%;
}

.cube-content .mode05 div:first-child,
.cube-content .mode06 div:nth-child(3) {
  min-height: 100%;
}

.mode-content {
  display: flex;
  flex-wrap: wrap;
}

.mode-content .list {
  border: 1px solid #e4e7ed;
  height: 50px;
  min-width: 80px;
  max-width: 80px;
  flex: 1;
  margin-right: 10px;
  margin-bottom: 10px;
}

.mode-content .list.active {
  border: 1px solid #409eff;
}

.mode-content .list > div {
  padding: 5px;
  height: 100%;
  cursor: pointer;
}

.mode-content .list .box.active div {
  background-color: #409eff;
}

.mode-content .list .box div {
  background-color: #e4e7ed;
  margin-right: 5px;
}

.mode-content .list .box div:last-child {
  margin-right: 0;
}

.mode-content .list .mode01,
.mode-content .list .mode02,
.mode-content .list .mode03,
.mode-content .list .mode04 {
  display: flex;
  flex-wrap: nowrap;
}

.mode-content .list .mode01 div,
.mode-content .list .mode02 div,
.mode-content .list .mode03 div,
.mode-content .list .mode04 div {
  height: 100%;
  flex: 1;
}

.mode-content .list .mode03 div:first-child,
.mode-content .list .mode04 div:nth-child(2) {
  flex: 2;
}

.mode-content .list .mode05,
.mode-content .list .mode06 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.mode-content .list .mode05 div,
.mode-content .list .mode06 div {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.mode-content .list .mode05 div:first-child {
  min-height: 100%;
}

.mode-content .list .mode05 div:nth-child(2) {
  margin-bottom: 5px;
  margin-right: 0;
}

.mode-content .list .mode06 div:first-child {
  margin-bottom: 5px;
}

.mode-content .list .mode06 div:nth-child(3) {
  min-height: 100%;
}
</style>
